import React from "react";
import { constants } from "../constants";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { formatDate } from "../util/dateUtil";
import { getDocumentDisplayStatus } from "../util/documentStatus";

const TableRow = ({ item, columns }) => {
  const navigate = useNavigate();
  const displayStatus = getDocumentDisplayStatus(item);

  const handleClick = (file) => {
    navigate("/data-mapping", { state: { fileName: file } });
  };

  return (
    <tr key={`${item.file_name}-${item.processed_at}`}>
      <td><span className="file-title">{item.file_name}</span></td>
      <td><span>{formatDate(item?.processed_at)}</span></td>
      <td><span>{item?.file_size}</span></td>
      <td><span>{item?.file_type}</span></td>
      <td><span>{item?.no_of_columns}</span></td>
      <td><span>{item?.success_row_count}</span></td>
      <td><span>{item?.failure_row_count}</span></td>
      <td><span>{item?.no_of_rows}</span></td>

      {/* PARTIAL_FAILURE:"Partial Failure",
    PARTIAL_SUCCESS:"Partial Success",
    REVIEWED:"Reviewed", */}

      {/* {item.status === constants.PARTIAL_FAILURE && (
        <td><span>
          <Button
            disabled={true}
            className={`btn-outline-steel-blue  me-2 dropdown-custom-color btn-failed`}
          >
            Partial Failure
          </Button>
        </span></td>
      )} */}

      {displayStatus === constants.PARTIAL_SUCCESS && (
        <td><span>
          <Button
            onClick={() => handleClick(item.file_name)}
            className={`btn-outline-steel-blue  me-2 dropdown-custom-color btn-passed`}
          >
            Partial Success
          </Button>
        </span></td>
      )}

      {(displayStatus === constants.STATUS_PASSED || displayStatus === "Verified") && (
        <td><span>
          <Button
            disabled={true}
            variant={displayStatus === "Verified" ? "success" : "primary"}
            className={`btn-outline-steel-blue ${
              displayStatus === "Verified" ? "" : "btn-light"
            } me-2 dropdown-custom-color btn-passed`}
          >
            {displayStatus}
          </Button>
        </span></td>
      )}
      {(displayStatus === constants.STATUS_FAILED || displayStatus === "Reviewed") && (
        <td><span>
          <Button
            onClick={() => handleClick(item.file_name)}
            className="btn-outline-steel-blue btn-light me-2 dropdown-custom-color btn-failed"
          >
            {displayStatus}
          </Button>
        </span></td>
      )}
      <td><span>{item?.failure_reasons}</span></td>
    </tr>
  );
};

export default TableRow;
